import {useDialog} from "../../../hooks/useDialog";
import React, {useState} from "react";
import {DynamicFields, fieldTemplateToColumn} from "../../../utils/dynamicFields";
import {FillerSection} from "../../FillerSection/FillerSection";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {FakeFieldGrid} from "../../FakeFieldGrid/FakeFieldGrid";
import {AddFieldTemplateDialog} from "../AddFieldTemplateDialog";
import {getNumericId} from "../../../utils/uniqueIds";

export const SelectOffenceListFiller = ({content, setFieldValue}) => {
    const {open, handleClose, handleOpen} = useDialog()
    const [selectedFieldTemplateIndex, setSelectedFieldTemplateIndex] = useState(null)

    const offenseWindow = content?.offenseWindow || []
    const tableConfig = content?.tableConfig || {columns: []}

    const handleFieldTemplateDelete = (deletedField, newFields) => {
        setFieldValue('content', {
            ...content,
            offenseWindow: newFields,
            filesVariable: DynamicFields.DRAG_AND_DROP_FILES_UPLOAD === deletedField.type ? '' : content?.filesVariable,
            normativeArticleVariable: deletedField.type === DynamicFields.NORMATIVE_ARTICLES_TABLE
            || deletedField.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ? '' : content?.normativeArticleVariable,
            tableConfig: {
                ...tableConfig,
                columns: tableConfig?.columns?.filter(f => f.field !== deletedField.variable)
            }
        })
    }

    const handleSequenceNumberChange = newFields => {
        setFieldValue('content.offenseWindow', newFields)
    }

    const handleFieldTemplateClick = index => {
        setSelectedFieldTemplateIndex(index)
        handleOpen()
    }

    const handleAddFieldTemplate = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: [...offenseWindow, {
                ...fieldTemplate,
                id: getNumericId(),
                sequenceNumber: offenseWindow.length + 1
            }],
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }

    const handleFieldTemplateChange = fieldTemplate => {
        setFieldValue('content', {
            ...content,
            offenseWindow: offenseWindow.map((el, i) => {
                if (i === selectedFieldTemplateIndex) {
                    return fieldTemplate
                }
                return el
            }),
            filesVariable: fieldTemplate.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD ?
                fieldTemplate.variable : content?.filesVariable,
            normativeArticleVariable: fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
            fieldTemplate.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ?
                fieldTemplate.variable : content?.normativeArticleVariable
        })
        handleClose()
        setSelectedFieldTemplateIndex(null)
    }

    const handleOffenceTableColumnChange = (_, value) => {
        setFieldValue('content.tableConfig.columns', value)
    }

    return <>
        <FillerSection title={'Таблица с нарушениями'}>
            <Autocomplete
                value={tableConfig?.columns || []}
                multiple
                onChange={handleOffenceTableColumnChange}
                options={offenseWindow.filter(f =>
                    !(f.type === DynamicFields.SELECTED_OFFENSE_LIST ||
                        f.type === DynamicFields.NORMATIVE_ARTICLE_SELECT ||
                        f.type === DynamicFields.NORMATIVE_ARTICLES_TABLE ||
                        f.type === DynamicFields.DRAG_AND_DROP_FILES_UPLOAD
                    )
                ).map(el => fieldTemplateToColumn(el))}
                getOptionLabel={(option) => option.headerName}
                getOptionSelected={(option, value) => option.field === value.field}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant={'outlined'}
                        size={'small'}
                    />
                )}
            />
        </FillerSection>
        <FakeFieldGrid fakeFields={offenseWindow}
                       handleAddButtonClick={handleOpen}
                       handleFieldTemplateDelete={handleFieldTemplateDelete}
                       handleSequenceNumberChange={handleSequenceNumberChange}
                       handleFieldTemplateClick={handleFieldTemplateClick}
                       setFieldValue={setFieldValue}
        />
        <AddFieldTemplateDialog open={open}
                                handleClose={handleClose}
                                handleSave={handleAddFieldTemplate}
                                handleFieldTemplateChange={handleFieldTemplateChange}
                                selectedFieldTemplate={selectedFieldTemplateIndex !== null ?
                                    offenseWindow[selectedFieldTemplateIndex] : null}
        />
    </>
}